export default "__VITE_ASSET__8bb5a838__"